import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import {
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Checkbox
} from '@material-ui/core';
import {
  ViewColumn as ViewColumnIcon,
  Delete as DeleteIcon,
  // Dock as DockIcon,
  AddBox as AddBoxIcon,
  Replay as RestartIcon
} from '@material-ui/icons';

// const Toolbar = styled(MuiToolbar)`
//   min-height: 36px;
// `;

// const IconButton = styled(MuiIconButton)`
//   padding-top: 0;
//   padding-bottom: 0;
// `;

// const Spacer = styled.div`
//   flex: 1;
// `;

function CTableToolbar (props) {
  const { selectedRowCount = 0, leftSideToolbarActions, onDelete, onSetDefault, onRestart } = props;
  const [columnsAnchorEl, setColumnAnchorEl] = useState(null);

  function showViewColumnIcon () {
    if (props.showColumns) {
      return (
        <span>
          <Tooltip title='Show columns'>
            <IconButton color='primary' onClick={e => setColumnAnchorEl(e.currentTarget)}>
              <ViewColumnIcon />
            </IconButton>
          </Tooltip>
          <Menu anchorEl={columnsAnchorEl} open={!!columnsAnchorEl} onClose={() => setColumnAnchorEl(null)}>
            {
              props.colDef.map(col => (
                <MenuItem key={col.title} onClick={() => props.onColumnChange(!col.hidden, col)}>
                  <Checkbox checked={!col.hidden} />
                  <Typography>{col.title}</Typography>
                </MenuItem>
              ))
            }
          </Menu>
        </span>
      );
    } else {
      return null;
    }
  }

  function showSetDefaultIcon () {
    if (onSetDefault && (selectedRowCount === 1)) {
      return (
        <span>
          <Tooltip title='Set as Default'>
            <IconButton color='primary' onClick={onSetDefault}>
              <AddBoxIcon />
            </IconButton>
          </Tooltip>
        </span>
      );
    } else {
      return null;
    }    
  }

  function showDeleteIcon () {
    if (onDelete) {
      return (
        <span>
          <Tooltip title='Delete'>
            <IconButton color='primary' onClick={onDelete}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </span>
      );
    } else {
      return null;
    }
  }

  function showRestartIcon () {
    if (onRestart) {
      return (
        <span>
          <Tooltip title='Restart'>
            <IconButton color='primary' onClick={onRestart}>
              <RestartIcon />
            </IconButton>
          </Tooltip>
        </span>        
      );
    }
  }

  function showLeftSideActions () {
    if (selectedRowCount) {
      return (
        <>
          {showDeleteIcon()}
          {showSetDefaultIcon()}
          {showRestartIcon()}
        </>
      )
    } else {
      return null;
    }
  }

  function showRightSideActions () {
    return (
      <>
        {showViewColumnIcon()}
      </>
    );
  }

  return (
    <Toolbar>
      {
        leftSideToolbarActions
          ? leftSideToolbarActions()
          : showLeftSideActions()
      }
      <div style={{ flex: 1 }} />
      {showRightSideActions()}
    </Toolbar>
  );
}

CTableToolbar.propTypes = {
  colDef: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedRowCount: PropTypes.number,
  showColumns: PropTypes.bool,
  leftSideToolbarActions: PropTypes.func,
  onColumnChange: PropTypes.func,
  onDelete: PropTypes.func,
  onSetDefault: PropTypes.func,
  onRestart: PropTypes.func
};

export default memo(CTableToolbar);
